"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _useQuery3 = _interopRequireDefault(require("../../../useQuery.js"));
var _adherenceQuery = _interopRequireDefault(require("./adherenceQuery.graphql"));
var _Callout = _interopRequireDefault(require("./components/Callout"));
var _round2 = _interopRequireDefault(require("lodash/round"));
var _mean2 = _interopRequireDefault(require("lodash/mean"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Component = function Component(props) {
  var colors = props.settings.colors;
  var isPreview = props.isPreview,
    query = props.query;
  var _useQuery = (0, _useQuery3["default"])({
      query: isPreview ? _adherenceQuery["default"] : query,
      variables: props.filters
    }),
    _useQuery2 = _slicedToArray(_useQuery, 2),
    data = _useQuery2[0],
    loading = _useQuery2[1];
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var calloutsData = props.convertDataStructure(data);
  var teen = calloutsData.teen,
    caregiver = calloutsData.caregiver,
    family = calloutsData.family;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.settings.show && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].callouts
  }, props.settings.teen.show && /*#__PURE__*/_react["default"].createElement(_Callout["default"], {
    handle: "teen",
    settings: _objectSpread(_objectSpread({}, props.settings.teen), {}, {
      colors: colors
    }),
    data: teen
  }), props.settings.caregiver.show && /*#__PURE__*/_react["default"].createElement(_Callout["default"], {
    handle: "caregiver",
    settings: _objectSpread(_objectSpread({}, props.settings.caregiver), {}, {
      colors: colors
    }),
    data: caregiver
  }), props.settings.family.show && /*#__PURE__*/_react["default"].createElement(_Callout["default"], {
    handle: "family",
    settings: _objectSpread(_objectSpread({}, props.settings.family), {}, {
      colors: colors
    }),
    data: family
  })));
};
Component.propTypes = {
  settings: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  filters: _propTypes["default"].object
};
Component.defaultProps = {
  filters: {},
  convertDataStructure: function convertDataStructure(data) {
    // console.log(data);
    var convertedData = {};
    if (data && data.groups.treatmentGroupList.length > 0) {
      var teenScores = [];
      var caregiverScores = [];
      var familyScores = [];
      data.groups.treatmentGroupList.forEach(function (tg) {
        var aps = tg.childRoles.metricspawn.assignmentProgressSummary;
        if (aps.youthFidelityScoreCombinedAvg !== null) {
          teenScores.push(aps.youthFidelityScoreCombinedAvg);
        }
        if (aps.caregiverFidelityScoreAvg !== null) {
          caregiverScores.push(aps.caregiverFidelityScoreAvg);
        }
        if (aps.familyFidelityScoreAvg !== null) {
          familyScores.push(aps.familyFidelityScoreAvg);
        }
      });

      // console.log(teenScores, caregiverScores, familyScores);

      var teenAdherenceAvg = teenScores.length > 0 ? (0, _round2["default"])((0, _mean2["default"])(teenScores)) : NaN;
      var caregiverAdherenceAvg = caregiverScores.length > 0 ? (0, _round2["default"])((0, _mean2["default"])(caregiverScores)) : NaN;
      var familyAdherenceAvg = familyScores.length > 0 ? (0, _round2["default"])((0, _mean2["default"])(familyScores)) : NaN;
      convertedData = {
        teen: {
          adherence: teenAdherenceAvg,
          target: 80
        },
        caregiver: {
          adherence: caregiverAdherenceAvg,
          target: 80
        },
        family: {
          adherence: familyAdherenceAvg,
          target: 80
        }
      };
    } else {
      convertedData = {
        teen: {
          adherence: 84,
          target: 80
        },
        caregiver: {
          adherence: 70,
          target: 80
        },
        family: {
          adherence: 56,
          target: 80
        }
      };
    }
    // console.log({ convertedData });
    return convertedData;
  }
};
var _default = exports["default"] = Component;